import {
    CompanySettingsGet,
    CompanySettingsSetRequest,
    IConnectionService,
    ProSettingsGetResponse,
    Ulid,
    UserSettingsGetResponse,
} from "@kase/my-marathon-communication";

type IgnoreUndefined<T> = T extends undefined ? never : T;

// @TODO: type is not exported from lib
export type IExpenseSettingsResponse = NonNullable<
    Awaited<ReturnType<IConnectionService["expense"]["settings"]>["cached"]>
>;

export enum CustomEntryPrio {
    Comment = 1,
    ClientFeeCode = 2,
    Client = 3,
    FeeCode = 4,
}

export interface UserSettings {
    id: string;
    _id: Readonly<Ulid>;
    time: Omit<
        IgnoreUndefined<UserSettingsGetResponse["time"]>,
        "custom_entry_prio"
    > & {
        _custom_entry_prio: number;
        customEntryPrio: CustomEntryPrio[];
    };
    expense: UserSettingsGetResponse["expense"] & object;
}

export interface ProUserSettings {
    id: string;
    _id: Readonly<Ulid>;
    time: ProSettingsGetResponse["time"];
}

export interface CompanySettings {
    id: string;
    _id: Readonly<Ulid>;
    expense: CompanySettingsGet["expense"] & object;
}

export interface SetUserSettingsRequest {
    time?: {
        customEntryPrio?: CustomEntryPrio[];
        suggest_description?: boolean;
        suggest_fee_code?: boolean;
        suggest_lob?: boolean;
        suggest_project?: boolean;
        use_start?: boolean;
    };
    expense?: {
        ocr_category_as_description?: boolean;
    };
}

export interface SetCompanySettingsRequest {
    expense?: CompanySettingsSetRequest["expense"];
}
